import React from 'react';

export type NavItem = { href: string; label: string };

type SidebarNavProps = { items: NavItem[] };

export default function SidebarNav({ items }: SidebarNavProps) {
  return (
    <nav aria-label="Section navigation">
      <ul className="m-0 list-none space-y-1 p-0">
        {items.map(item => (
          <li key={item.href}>
            <a
              className="block rounded-md px-2 py-1.5 text-slate-100 outline-none hover:bg-slate-800/60 focus:bg-slate-800/60"
              href={item.href}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
